import axios from 'axios'
import { message } from 'ant-design-vue'
import { hasRecentGatewayRedirect, redirectToGatewayLogin, refreshGatewayAccessToken } from './auth'
import { pinia } from '@/store'
import { useSessionStore } from '@/store/session'

// 创建 axios 实例
const service = axios.create({
  baseURL: '/',
  timeout: 60 * 1000,
  validateStatus(status) {
    return status >= 200 && status <= 500
  },
})

service.interceptors.request.use(
  (config) => {
    const session = useSessionStore(pinia)
    const accessToken = session.accessToken
    if (accessToken && !config.headers?.Authorization) {
      config.headers = {
        ...(config.headers || {}),
        Authorization: `Bearer ${accessToken}`,
      }
    }
    return config
  },
  (error) => Promise.reject(error)
)

// 统一响应处理
const responseInterceptor = async (response) => {
  const payload = response.data
  const isBlob = response.request?.responseType === 'blob' || response.config?.responseType === 'blob'
  const wrapped = !isBlob && payload && typeof payload === 'object' && !Array.isArray(payload)
    && Object.prototype.hasOwnProperty.call(payload, 'code')
    && Object.prototype.hasOwnProperty.call(payload, 'message')
    && Object.prototype.hasOwnProperty.call(payload, 'result')

  const statusCode = wrapped ? payload.code : response.status
  const messageText = wrapped ? payload.message : payload?.message
  const result = wrapped ? payload.result : payload

  switch (response.status) {
    case 200:
      break
    case 401: {
      const originalRequest = response.config || {}
      if (shouldRetryWithGatewayRefresh(originalRequest)) {
        originalRequest.__gatewayRetry = true
        const refreshed = await refreshGatewayAccessToken()
        const accessToken = refreshed?.data?.accessToken
        if (refreshed.status === 200 && accessToken) {
          const session = useSessionStore(pinia)
          session.applyGatewayProfile(refreshed.data)
          originalRequest.headers = {
            ...(originalRequest.headers || {}),
            Authorization: `Bearer ${accessToken}`,
          }
          return service(originalRequest)
        }
      }

      useSessionStore(pinia).clear()
      if (hasRecentGatewayRedirect()) {
        window.location.href = `/login-failed?reason=session_expired&message=${encodeURIComponent(messageText || '统一认证后仍未建立有效会话')}`
      } else {
        message.error('当前登录已过期，正在跳转统一登录')
        redirectToGatewayLogin(window.location.pathname + window.location.search)
      }
      break
    }
    case 403:
      message.error(messageText || '当前账号没有访问该功能的权限')
      break
    default:
      if (response?.data?.message) {
        console.log(response.data.message)
      }
      break
  }
  return {
    data: result,
    status: statusCode,
    message: messageText,
  }
}
const errorInterceptor = (error) => Promise.reject(error)

function shouldRetryWithGatewayRefresh(config = {}) {
  if (config.__gatewayRetry) return false
  const url = String(config.url || '').trim()
  return url !== '/bff/refresh' && url !== '/bff/logout'
}

service.interceptors.response.use(responseInterceptor, errorInterceptor)

export default service
